document.addEventListener("submit", function(event) {
  const form = event.target;
  if (form && form.id === "add-to-cart-form") {
    event.preventDefault(); // stop add-to-cart

    // OPEN MODAL ONLY
    let modal = document.querySelector(".modal");
    if (modal) modal.style.display = "block";
updateDiscountProgress();
    let cartDrawer = document.querySelector(".cart-drawer");
    if (cartDrawer) cartDrawer.classList.add("is-active");
prepareModalForOpen();

    console.log("Add to cart prevented — modal opened.");
  }
});
document.addEventListener("click", function (event) {
  const modal = document.querySelector(".modal");
  const modalContent = document.querySelector(".modal-content");

  if (!modal) return;

  // If modal is visible AND click is outside modal-content → close
  if (modal.style.display === "block" && !modalContent.contains(event.target)) {
    modal.style.display = "none";
  }
});



function updateDiscountProgress(goalAmount = 250) {
  const startAmount = 100;

  const fill = document.querySelector('.discount-progress-fill');
  const message = document.querySelector('.discount-message');
  const remainingText = document.querySelector('.discount-remaining-text');

  if (!fill) {
    console.warn('discount-progress-fill element not found');
    return;
  }

  const activeItems = document.querySelectorAll('.product-item.active');
  let total = 0;

  activeItems.forEach(item => {
    const priceEl = item.querySelector('.price-popup');
    const qtyEl = item.querySelector('input.qty-input');

    if (!priceEl || !priceEl.textContent) return;

    const cleaned = priceEl.textContent.replace(/[^\d.]/g, '');
    const priceNum = Number(cleaned);

    let quantity = Number(qtyEl?.value) || 1;

    if (!isNaN(priceNum)) total += priceNum * quantity;
  });

  const grand = startAmount + total;
  window.grandTotal = grand;

  let percentage = (grand / goalAmount) * 100;
  if (!isFinite(percentage) || percentage < 0) percentage = 0;
  if (percentage > 100) percentage = 100;

  fill.style.width = `${percentage}%`;

  fill.style.backgroundColor = fill.style.backgroundColor || '#2ecc71';

  if (grand >= goalAmount) {
    fill.classList.add('unlocked');
    if (message) message.textContent = '🎉 You unlocked 1 free item!';
    if (remainingText) remainingText.textContent = 'Reward unlocked!';
  } else {
    fill.classList.remove('unlocked');
    const remaining = (goalAmount - grand).toFixed(2);
    if (message) message.textContent = 'Spend $150, get a free base panel (a $99 value)';
    if (remainingText) remainingText.textContent = `Add $${remaining} more`;
  }
}







const container = document.querySelector("#product-list"); // change to your container

const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    mutation.addedNodes.forEach(node => {
      if (node.nodeType !== 1) return; // only elements
      if (node.matches && node.matches(".select-btn")) {
        // Fix button attributes to ensure it can be clicked
        node.disabled = false;
        node.removeAttribute("disabled");
        node.style.pointerEvents = "auto";
      }
      // Also check inside subtree if new buttons are added inside other nodes
      node.querySelectorAll && node.querySelectorAll(".select-btn").forEach(btn => {
        btn.disabled = false;
        btn.removeAttribute("disabled");
        btn.style.pointerEvents = "auto";
      });
    });
  });
});

observer.observe(container, { childList: true, subtree: true });



document.addEventListener("DOMContentLoaded", function () {

   let confirmSelection = document.querySelector("#confirm-selection2");

      document.addEventListener("click", function (event) {
    if (event.target.classList.contains("select-btn")) {
  
        confirmSelection.classList.remove("disabled"); 
    }
  });
      // Update on each select button click
  document.querySelectorAll(".select-btn").forEach(btn => {
    btn.addEventListener("click", function () {

      updateDiscountProgress();
      
 
    });
  });

  // Update after confirm selection (multi-add)
  const confirmBtn = document.querySelector("#confirm-selection2");
  if (confirmBtn) {
    confirmBtn.addEventListener("click", function () {
      setTimeout(updateDiscountProgress, 800);
    });
  }

  // Update on unselect
  document.addEventListener("click", function (e) {
    if (e.target.classList.contains("unselect-btn")) {

      setTimeout(updateDiscountProgress, 300);
    }
  });

  // Initial load

  updateDiscountProgress();

});












function refreshMainCartDrawer(html){
     // Parse the returned HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        // Extract the new cart drawer content
        const newCartDrawerContent = doc.querySelector("cart-drawer").innerHTML;

        // Update the existing cart drawer with the new content
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) {
          cartDrawer.innerHTML = newCartDrawerContent;

          // Open the cart drawer
          // cartDrawer.classList.add("active");

          // Remove "is-empty" class if present
          if (cartDrawer.classList.contains("is-empty")) {
            cartDrawer.classList.remove("is-empty");
          }

          // Reinitialize any necessary scripts to ensure functionality
          reinitializeCartDrawerScripts();
        }
}

// Function to reinitialize cart drawer scripts
function reinitializeCartDrawerScripts() {
  // Example: Reattach event listeners or reinitialize plugins
  // This is a placeholder; actual implementation depends on the theme's scripts

  // For instance, if the theme uses a specific function to initialize the cart drawer:
  if (window.Shopify && Shopify.theme && typeof Shopify.theme.init === "function") {
    Shopify.theme.init();
  }

  // If there are specific event listeners for cart drawer elements, reattach them here
  // Example:
  const closeButton = document.querySelector("cart-drawer .drawer__close");
  if (closeButton) {
    closeButton.addEventListener("click", function () {
      const cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer) {
        cartDrawer.classList.remove("is-open");
      }
    });
  }
}

// Refresh ONLY the cart drawer section (no page reload)
function refreshCartDrawer() {
  fetch('/?section_id=cart-drawer')
    .then(res => res.text())
    .then(html => {
      const temp = document.createElement('div');
      temp.innerHTML = html;

      const newDrawer = temp.querySelector('#CartDrawer');
      const oldDrawer = document.querySelector('#CartDrawer');

      if (newDrawer && oldDrawer) {
        oldDrawer.replaceWith(newDrawer);
        console.log("Cart drawer refreshed.");
      } else {
        console.warn("Cart drawer section not found.");
      }
    })
    .catch(err => console.error("Error refreshing cart drawer:", err));
}

    
  


  

    // ✅ Function to update cart count
    function updateCartCount() {
      console.log("i m here")
       fetch('/cart.js')
     .then(response => response.json())
     .then(data => {
      const cartCounter = document.querySelector('.cart-count-bubble');
      if (cartCounter) {
        cartCounter.innerText = data.item_count;
      }
     })
     .catch(error => console.error("Error updating cart count:", error));
}




  //cofirmation selection 2 add to cart
// Confirmation selection 2 add to cart
let confirmSelection2 = document.querySelector("#confirm-selection2");
let modal = document.querySelector(".modal");
let cartDrawer = document.querySelector(".cart-drawer");
let selectedVariantId = null; // Store selected variant ID

// When a product is selected
document.addEventListener("click", function (event) {
    if (event.target.classList.contains("select-btn")) {
    
        let productItem = event.target.closest(".product-item"); // Use event.target
        if (!productItem) return; // Ensure productItem exists
       let unselectBtn = productItem.querySelector(".unselect-btn");
    if (unselectBtn) unselectBtn.style.display = "inline-block"; 
        selectedVariantId = productItem.dataset.variantId; // Get variant ID
        console.log("Selected Variant ID:", selectedVariantId);
        
        // Enable the confirm selection button
        confirmSelection2.classList.remove("disabled");
    }
});


document.addEventListener("DOMContentLoaded", function () {
  function getCurrentVariantIdFromScript() {
  const variantScript = document.querySelector('variant-selects > script[data-selected-variant]');
  if (variantScript) {
    try {
      const variantData = JSON.parse(variantScript.textContent);
      return variantData.id || null;
    } catch(e) {
      console.error('Error parsing variant JSON:', e);
      return null;
    }
  }
  return null;
}


function applyFreePanelIfEligible() {
  const START_AMOUNT = 100;
  const THRESHOLD = 250;
  const EXCLUDED_PRODUCT_ID = 9033685336380;

  const currentVariantId = getCurrentVariantIdFromScript();
  if (!currentVariantId) return;

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {

      // If excluded product is in cart, skip the free panel logic
      const hasExcludedProduct = cart.items.some(item => Number(item.variant_id) === EXCLUDED_PRODUCT_ID);
      if (hasExcludedProduct) {
        console.log(`Product ID ${EXCLUDED_PRODUCT_ID} found in cart. Skipping free panel logic.`);
        return;
      }

      // 1️⃣ Calculate subtotal WITHOUT the free panel item
      let productsTotalCents = 0;

      cart.items.forEach(item => {
        if (Number(item.variant_id) !== Number(currentVariantId)) {
          productsTotalCents += item.original_price * item.quantity; 
        }
      });

      // convert cents → dollars
      const productsTotal = productsTotalCents / 100;
      const grandTotal = START_AMOUNT + productsTotal;

      // 2️⃣ Check if panel is already in cart
      const panelItem = cart.items.find(i => Number(i.variant_id) === Number(currentVariantId));

      // 3️⃣ Eligible → mark as free
      if (grandTotal >= THRESHOLD) {
        if (panelItem && (!panelItem.properties || panelItem.properties._free !== "yes")) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: panelItem.key,
              quantity: panelItem.quantity,
              properties: Object.assign({}, panelItem.properties || {}, { _free: 'yes' })
            })
          }).then(() => {
            refreshCartDrawer?.();
            console.log("Panel marked FREE");
          });
        }
      }

      // 4️⃣ Not eligible → remove free flag
      else {
        if (panelItem && panelItem.properties && panelItem.properties._free === "yes") {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: panelItem.key,
              quantity: panelItem.quantity,
              properties: {} // remove _free
            })
          }).then(() => {
            refreshCartDrawer?.();
            console.log("Free flag removed");
          });
        }
      }
    });
}





console.log("Current Variant ID:", getCurrentVariantIdFromScript());

    let confirmSelection2 = document.querySelector("#confirm-selection2");

    /* -------------------------------------------
       1️⃣  MARK ACTIVE PRODUCT WHEN SELECT BUTTON IS CLICKED
    --------------------------------------------*/
document.addEventListener("click", function (event) {
    if (event.target.classList.contains("select-btn")) {
        let product = event.target.closest(".product-item");
        if (!product) return;

        // Toggle active class here (this duplicates your current .forEach handler, but ensures it always fires)
        product.classList.toggle("active");
    updateDiscountProgress();
        const activeProducts = document.querySelectorAll(".product-item.active");
        const selectedVariants = Array.from(activeProducts).map(p => p.dataset.variantId);

        console.log("Currently selected variants (delegated):", selectedVariants);

        // Enable confirm button if needed
        if (typeof confirmSelection2 !== "undefined" && confirmSelection2.classList) {
            confirmSelection2.classList.remove("disabled");
        }
    }
});


(function(history) {
  const pushState = history.pushState;
  const replaceState = history.replaceState;

  history.pushState = function(state, title, url) {
    const result = pushState.apply(history, arguments);
    window.dispatchEvent(new Event('urlchange'));
    return result;
  };

  history.replaceState = function(state, title, url) {
    const result = replaceState.apply(history, arguments);
    window.dispatchEvent(new Event('urlchange'));
    return result;
  };
})(window.history);



function updateButtonState() {
  const variantId = getCurrentVariantIdFromScript();
  const button = document.querySelector('.button-name');
  if (!button) {
    console.warn('Button with class .button-name not found');
    return;
  }

  if (!variantId) {
    console.warn('No variant ID found');
    button.textContent = "Unavailable";
    button.disabled = true;
    return;
  }

  // window.variantAvailability should be an object like { "variantId": true/false }
  const isAvailable = window.variantAvailability?.[variantId];

  console.log(`Variant ${variantId} availability:`, isAvailable);

  if (isAvailable) {
    button.textContent = "Build your Kit";
    button.disabled = false;
    button.style.display = "block";
  } else {
    // button.textContent = "Out of stock";
    button.style.display = "none";
    button.disabled = true;
  }
}

// Initial check on page load
document.addEventListener('DOMContentLoaded', updateButtonState);

// Update on URL changes (pushState/replaceState)
window.addEventListener('urlchange', updateButtonState);

// Also update on browser back/forward navigation
window.addEventListener('popstate', updateButtonState);


    /* -------------------------------------------
       2️⃣  CONFIRM SELECTION → ADD PRODUCT(S) TO CART
    --------------------------------------------*/
    confirmSelection2.addEventListener("click", function () {

        const activeProducts = document.querySelectorAll(".product-item.active");
console.log('activeProducts:', activeProducts.length);
        // if (activeProducts.length > 0) {
        //      confirmSelection2.textContent = "Confirm Selection";
        // confirmSelection2.classList.remove("disabled");
        //     // return;
        // }

        const itemsToAdd = [];

        // Add selected items
        activeProducts.forEach(product => {
            const variantId = Number(product.dataset.variantId);
            const qtyInput = product.querySelector(".qty-input");
            const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

            if (variantId && quantity > 0) {
                itemsToAdd.push({ id: variantId, quantity: quantity });
            }
        });

        if (itemsToAdd.length === 0) {
            alert("No valid products selected.");
            return;
        }

        /* -------------------------------------------
            ⭐ ADD BASE PANEL (ID: 51762929762620)
        --------------------------------------------*/
const currentVariantId = getCurrentVariantIdFromScript();
// const freeVariantId = FREE_VARIANT_MAP[paidVariantId];
// console.log(freeVariantId, window.grandTotal);
// let panelToAdd = paidVariantId; // default = paid

// If user reached $250 → use free variant
// if (window.grandTotal >= 250 && freeVariantId) {
//   panelToAdd = freeVariantId;
// }

if (currentVariantId) { itemsToAdd.push({ id: currentVariantId, quantity: 1 }); 
console.log("Base panel added with variant:", currentVariantId); } else { console.log("No current variant ID found"); }






        /* -------------------------------------------
             3️⃣ SEND TO CART
        --------------------------------------------*/
        const firstModal = document.getElementById("first-modal");
        const addingToCartModal = document.getElementById("confirmation-modal");

        fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items: itemsToAdd }),
        })
        .then(res => {
            if (!res.ok) {
                return res.json().then(errData => {
                    const errorMsg = errData.description || errData.message || "Failed to add to cart";
                    throw new Error(errorMsg);
                });
            }
            return res.json();
        })
        .then(data => {
            return fetch("/?section_id=cart-drawer")
                .then(res => res.text())
                .then(html => ({ data, html }));
        })
        .then(({ data, html }) => {

            refreshMainCartDrawer(html);
            refreshCartDrawer();
            updateCartCount();
            updateCartIconBubble();
            updateDiscountProgress(250);
            applyFreePanelIfEligible();

            let successMessage = document.querySelector("#success-modal .modal-body p");
            if (successMessage) {
                successMessage.textContent = `Selected products were added to the cart successfully.`;
            }

            setTimeout(() => {
                if (firstModal) firstModal.style.display = "none";

                setTimeout(() => {
                    if (addingToCartModal) {
                        addingToCartModal.style.display = "block";

                        setTimeout(() => {
                            addingToCartModal.style.display = "none";
                            document.getElementById("success-modal").style.display = "block";
                        }, 1000);
                    }
                    document.querySelectorAll('.whole-model .checkout-btn, #view-cart-btns')
                .forEach(btn => {
                    btn.addEventListener('click', function(e) {
                      
                        document.getElementById("success-modal").style.display = "none";
                    });
                });
                }, 1000);
             resetModalSelections();}, 1000);
            
        })
        .catch(err => {
            console.error("Error adding items:", err);
            alert("Error adding to cart: " + err.message);
        });
    });

});




  
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".confirm-select").forEach((btn) => {
        btn.addEventListener("click", function () {
            let productItem = this.closest(".product-item");
            
            // Check if productItem is found
            if (!productItem) {
                console.error("Error: Could not find product item.");
                return;
            }

            // let selectedVariant = productItem.querySelector("input[type='radio']:checked");
            let variantId =  productItem.getAttribute("data-variant-id");

            console.log("Product Handle:", productItem.getAttribute("data-handle"));
            // console.log("Selected Variant Element:", selectedVariant);
            console.log("Selected Variant ID:", variantId);

            if (!variantId || variantId === "null" || variantId === "undefined") {
                alert("Error: No valid variant found for this product.");
                return;
            }
           let firstModal = document.getElementById("first-modal");
  let addingToCartModal = document.getElementById("confirmation-modal");
           

            fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: variantId, quantity: 1 })
})
.then(response => {
    if (!response.ok) {
        throw new Error("Network response was not ok");
    }
    return response.json();
})
.then(data => {
    console.log("Product added:", data);

    // Fetch updated cart contents
    return fetch("/?section_id=cart-drawer")
        .then(response => response.text())
        .then(html => ({ data, html })); // Pass both data and HTML forward
})
.then(({ data, html }) => {
    refreshMainCartDrawer(html);
  updateCartIconBubble();
                 
        refreshCartDrawer(); // ✅ Refresh the cart drawer
        updateCartCount(); // ✅ Update cart count
    // Update cart count in header
    const cartCount = document.querySelector(".cart-count-bubble .cart-count");
    if (cartCount) {
        const itemCountMatch = html.match(/"item_count":(\d+)/);
        if (itemCountMatch) {
            const itemCount = parseInt(itemCountMatch[1], 10);
            cartCount.textContent = itemCount;
        }
    }

    updateCartIconBubble();

    // Update success message
    let productName = data.product_title || "Product"; // Use correct key
    let successMessage = document.querySelector("#success-modal .modal-body p");
    if (successMessage) {
        successMessage.textContent = `MoonShade XL and ${productName} were added to the cart successfully.`;
    }

    setTimeout(() => {
        if (firstModal) firstModal.style.display = "none";

        if (addingToCartModal) addingToCartModal.style.display = "none";
        let successModal = document.getElementById("success-modal");
        if (successModal) successModal.style.display = "block";
    }, 1000);
})
.catch(error => console.error("Error adding to cart:", error));





          
        });
    });
});



document.addEventListener("DOMContentLoaded", function () {
    let viewCartBtn = document.getElementById("view-cart-btns");

    if (viewCartBtn) {
        viewCartBtn.addEventListener("click", function (event) {
            event.preventDefault(); // Prevent default link behavior
            
            let cartDrawer = document.querySelector("cart-drawer"); // Select cart drawer
            
            if (cartDrawer) {
                cartDrawer.classList.add("active"); // Add active class to open the drawer
            }
        });
    }
});

document.addEventListener("DOMContentLoaded", function () {
    let selectedProductId = null;
    let selectedVariantId = null;
    let confirmSelectionBtn = document.getElementById("confirm-selection");
    let selectButtons = document.querySelectorAll(".select-btn");
    
    // confirmSelectionBtn.disabled = true;

    selectButtons.forEach(button => {
        button.addEventListener("click", function () {
        
            let productItem = this.closest(".product-item");
            let variantId = productItem.dataset.variantId;

            selectedProductId = productItem.dataset.handle;
            selectedVariantId = variantId;
            let selectedInfo = productItem.querySelector(".selected-info");
            if (selectedInfo) selectedInfo.style.display = "block";

            confirmSelectionBtn.disabled = false;
        });
    });

    confirmSelectionBtn.addEventListener("click", function () {
        if (!selectedVariantId) {
            alert("Please select an anchor hardware first!");
            return;
        }

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: selectedVariantId, quantity: 1 })
        })
        .then(res => res.json())
        .then(data => {
            console.log("Product added:", data);
            document.getElementById("success-modal").style.display = "block";
        })
        .catch(err => console.error("Cart error:", err));
    });

    document.querySelectorAll(".close").forEach(c => {
        c.addEventListener("click", () => {
            document.getElementById("success-modal").style.display = "none";
        });
    });
});


// ✅ Confirmation Modal Handling
document.addEventListener("DOMContentLoaded", function () {
    let confirmSelectionBtn = document.getElementById("confirm-selection");
    let confirmationModal = document.getElementById("confirmation-modal");

    // if (confirmSelectionBtn) {
    //     confirmSelectionBtn.addEventListener("click", function () {
    //         if (confirmationModal) {
    //             confirmationModal.style.display = "block";
    //         }
    //     });
    // }

    // ✅ Modal close functionality
    let closeConfirmModal = document.querySelector("#confirmation-modal .close");
    if (closeConfirmModal) {
        closeConfirmModal.addEventListener("click", function () {
            confirmationModal.style.display = "none";
        });
    }
});

// ✅ Hide main modal and show confirmation modal
document.addEventListener("DOMContentLoaded", function () {
    let confirmSelectionBtn = document.getElementById("confirm-selection");
    let confirmationModal = document.getElementById("confirmation-modal");
    let mainModal = document.querySelector(".modal"); // ✅ Main modal select karein

    if (confirmSelectionBtn) {
        confirmSelectionBtn.addEventListener("click", function () {
            if (confirmationModal) {
                confirmationModal.style.display = "block";
            }
            if (mainModal) {
                mainModal.style.display = "none"; // ✅ Main modal hide karein
            }
        });
    }

    // ✅ Confirmation modal close karne ka function
    let closeConfirmModal = document.querySelector("#confirmation-modal .close");
    if (closeConfirmModal) {
        closeConfirmModal.addEventListener("click", function () {
            confirmationModal.style.display = "none";
        });
    }
});

// ✅ Success Modal Handling
document.addEventListener("DOMContentLoaded", function () {
    let confirmSelectionBtn = document.getElementById("confirm-selection");
  console.log(confirmSelectionBtn)
    let confirmationModal = document.getElementById("confirmation-modal");
  console.log(confirmationModal)
  
    let successModal = document.getElementById("success-modal"); // ✅ Naya success modal
    let mainModal = document.querySelector(".modal"); // ✅ Pehla modal

    if (confirmSelectionBtn) {
        confirmSelectionBtn.addEventListener("click", function () {
            if (confirmationModal) {
                confirmationModal.style.display = "block"; // ✅ Confirmation modal show karein
            }
            if (mainModal) {
                mainModal.style.display = "none"; // ✅ Main modal hide karein
            }

            // ✅ 2 sec ke baad confirmationModal hide karke successModal show karein
            setTimeout(function () {
                confirmationModal.style.display = "none"; // ✅ Hide confirmation modal
                if (successModal) {
                    successModal.style.display = "block"; // ✅ Success modal show karein
                }
            }, 2000); // ✅ 2 seconds delay
        });
    }

    // ✅ Success modal close button functionality
    let closeSuccessModal = document.querySelector("#success-modal .close");
    if (closeSuccessModal) {
        closeSuccessModal.addEventListener("click", function () {
            successModal.style.display = "none"; // ✅ Success modal hide karein
        });
    }


        document.querySelectorAll(".select-btn").forEach(function (button) {
        button.addEventListener("click", function () {
            let moreDetailsBtn = this.parentElement.querySelector(".more-details-btn");
            if (moreDetailsBtn) {
                moreDetailsBtn.style.display = "none";
            }
        });
    });
});





document.addEventListener("DOMContentLoaded", function () {
    let selectedProductId = null;
    let selectButtons = document.querySelectorAll(".select-btn");

    selectButtons.forEach(btn => {
        btn.addEventListener("click", function () {

            let productItem = this.closest(".product-item");
            selectedProductId = productItem.getAttribute("data-handle");

            // ❌ REMOVE THIS – It clears all previously selected items
            // document.querySelectorAll(".selected-info").forEach(info => {
            //     info.style.display = "none";
            // });

            // ❌ REMOVE THIS – It restores all select buttons globally
            // document.querySelectorAll(".select-btn").forEach(button => {
            //     button.style.display = "inline-block";
            // });

            // ✅ New: Only hide THIS product's select button
            this.style.display = "none";

            // Show THIS product’s selected-info
            let selectedInfo = productItem.querySelector(".selected-info");
            selectedInfo.style.display = "block";

            // Enable confirm button inside THIS block
            let confirmBtn = selectedInfo.querySelector("#confirm-selection");
            confirmBtn.style.display = "block";

            // Confirm selection logic
            confirmBtn.addEventListener("click", function () {
                let hiddenInput = document.getElementById("main-product-id");
                if (hiddenInput) {
                    hiddenInput.value = selectedProductId;
                }

                let confirmationModal = document.getElementById("confirmation-modal");
                if (confirmationModal) {
                    confirmationModal.style.display = "block";
                }
            });
        });
    });
});




  document.addEventListener("DOMContentLoaded", function () {
    // ✅ Confirmation Modal Close Button
    document.querySelectorAll("#confirmation-modal .close, #success-modal .close").forEach((btn) => {
        btn.addEventListener("click", function () {
            let modal = this.closest(".modal");
            if (modal) {
                modal.style.display = "none";
            }
        });
    });

    // ✅ Success Modal ko close karne ka event
    document.querySelector("#success-modal").addEventListener("click", function (event) {
        if (event.target.classList.contains("modal")) {
            this.style.display = "none";
        }
    });


      document.querySelector('body').addEventListener('click', (e) => {
     let modal = document.getElementById('first-modal');
    let modalContent = modal.querySelector('.modal-content');

    // Check if clicked element is inside modal-content, if not, hide modal
    if (!modalContent.contains(e.target)) {
        modal.style.display = "none";
    }
})


});


  




  function updateCartIconBubble() {
    const cartIconBubble = document.querySelector("#cart-icon-bubble");
    console.log("cartIconBubble",cartIconBubble)
    if (!cartIconBubble) {
        console.error("Cart icon bubble container not found!");
        return;
    }

    // Check if the cart count bubble already exists
    if (!cartIconBubble.querySelector(".cart-count-bubble")) {
        // Create the cart count bubble
        const bubble = document.createElement("div");
        bubble.classList.add("cart-count-bubble");
        bubble.innerHTML = `
            <span aria-hidden="true">1</span>
            <span class="visually-hidden">1 items</span>
        `;
        
        cartIconBubble.appendChild(bubble);
        console.log("Cart count bubble added!");
    } else {
        console.log("Cart count bubble already exists, no changes made.");
    }
}


  document.addEventListener("DOMContentLoaded", function () {
  // Select all buttons with the class 'select-btn'
  document.querySelectorAll(".select-btn").forEach(function (button) {
    button.addEventListener("click", function () {
      // Find the parent product item
      let parentProductItem = this.closest(".product-item");
  
      // Change the background color
      parentProductItem.style.backgroundColor = "#fbf5e766";

      // Show the selected-info section
      let selectedInfo = parentProductItem.querySelector(".selected-info");
      if (selectedInfo) {
        selectedInfo.style.display = "block";
      }

      // Disable the select button
      this.disabled = true;
    });
  });
});







document.addEventListener("DOMContentLoaded", function () {

    const unselectBtns = document.querySelectorAll(".unselect-btn");

    unselectBtns.forEach(btn => {
        btn.addEventListener("click", function () {

            const productItem = this.closest(".product-item");
            if (!productItem) return;

            // Remove active state
            productItem.classList.remove("active");

            // Hide selected info
            const selectedInfo = productItem.querySelector(".selected-info");
            if (selectedInfo) {
                selectedInfo.style.display = "none";
            }

            // 👉 SHOW the select button again
            const selectBtn = productItem.querySelector(".select-btn");
            if (selectBtn) {
                selectBtn.style.display = "inline-block";
                 selectBtn.disabled = false;
            }

            // Reset global selected IDs
            window.selectedProductId = null;
            window.selectedVariantId = null;

            console.log("Product unselected");
        });
    });

});


document.addEventListener("DOMContentLoaded", function () {
  const confirmBtn = document.getElementById("confirm-selection2");
  let confirmed = false;

  if (confirmBtn) {
    confirmBtn.addEventListener("click", () => {
      confirmed = true;
    });
  }

  document.querySelectorAll(".modal").forEach(modal => {

    // Close modal on close button click
    modal.querySelectorAll(".close").forEach(closeBtn => {
      closeBtn.addEventListener("click", () => {
        closeModal(modal);
      });
    });

    // Close modal on clicking outside modal content (overlay)
    modal.addEventListener("click", (e) => {
      if (e.target === modal) {
        closeModal(modal);
      }
    });
  });

  function closeModal(modal) {
  modal.style.display = "none";

  if (!confirmed) {
    // Clear active class from all product items
    document.querySelectorAll(".product-item.active").forEach(item => {
      item.classList.remove("active");

      // Hide unselect-btn inside this product item
      item.querySelectorAll(".unselect-btn").forEach(btn => {
        btn.style.display = "none";
      });
      item.querySelectorAll(".selected-info").forEach(btn => {
        btn.style.display = "none";
      });
      // Show select-btn inside this product item
      item.querySelectorAll(".select-btn").forEach(btn => {
        btn.style.display = "inline-block";
        btn.disabled = false;
        btn.removeAttribute("disabled");
        btn.style.pointerEvents = "auto";
      });
    });

    console.log("Modal closed without confirm → cleared active and reset buttons");
  } else {
    
    console.log("Modal closed after confirm → keep active and buttons");
  }

  // Reset flag for next open
  confirmed = false;
  }



});


function resetModalSelections() {
  // Clear active class from all product items
  document.querySelectorAll(".product-item.active").forEach(item => {
    item.classList.remove("active");

    // Hide unselect-btn
    item.querySelectorAll(".unselect-btn").forEach(btn => {
      btn.style.display = "none";
    });

    // Hide selected-info
    item.querySelectorAll(".selected-info").forEach(btn => {
      btn.style.display = "none";
    });

    // Show select-btn
    item.querySelectorAll(".select-btn").forEach(btn => {
      btn.style.display = "inline-block";
      btn.disabled = false;
      btn.removeAttribute("disabled");
      btn.style.pointerEvents = "auto";
    });
  });

  // Reset progress bar
  updateDiscountProgress(250);

  console.log("Modal selections reset completely.");
}
function prepareModalForOpen() {
  // Remove active from all items
  document.querySelectorAll(".product-item").forEach(item => {
    item.classList.remove("active");

    // Hide unselect
    item.querySelectorAll(".unselect-btn").forEach(btn => {
      btn.style.display = "none";
    });

    // Hide selected-info
    item.querySelectorAll(".selected-info").forEach(btn => {
      btn.style.display = "none";
    });

    // Always show select button
    item.querySelectorAll(".select-btn").forEach(btn => {
      btn.style.display = "inline-block";
      btn.disabled = false;
      btn.removeAttribute("disabled");
      btn.style.pointerEvents = "auto";
    });
  });

  // Reset progress bar
  updateDiscountProgress(250);

  console.log("Modal prepared for open → all selections reset");
}
